import { SORTIE_LEVELS } from 'constants'

export const sortSortieLevels = (firstLevel, secondLevel) => {
    return Math.sign(SORTIE_LEVELS[firstLevel] - SORTIE_LEVELS[secondLevel])
}



// WEBPACK FOOTER //
// ./helpers/battles.js